/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

const FlagIcon = ({ width = '11px', height = '15px', ...rest }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} {...rest} viewBox="0 0 11.884 15.354">
		<path
			d="M89.186,102.521h-.012a1,1,0,0,0-.337.073l-.513.256a3.422,3.422,0,0,1-3.545-.277l-1.077-.762a3.587,3.587,0,0,0-4.288.053l-1.079.815a.752.752,0,0,0-.3.578v12.508a.735.735,0,0,0,.735.715h.019a.725.725,0,0,0,.514-.228.733.733,0,0,0,.2-.523l.014-4.485.778-.581a2.145,2.145,0,0,1,2.555-.034l1.079.761a4.951,4.951,0,0,0,5.067.4l.52-.26a.745.745,0,0,0,.4-.665v-7.622A.737.737,0,0,0,89.186,102.521Zm-.732,1.876v6.032l-.121.053a3.415,3.415,0,0,1-3.541-.279l-1.08-.762a3.568,3.568,0,0,0-2.1-.677h-.018a3.637,3.637,0,0,0-2.073.652v-5.791l.778-.581a2.147,2.147,0,0,1,2.555-.036l1.079.762A4.924,4.924,0,0,0,88.454,104.4Z"
			transform="translate(-78.038 -101.126)"
		/>
	</svg>
);

FlagIcon.propTypes = {
	width: PropTypes.string,
	height: PropTypes.string
};

export default FlagIcon;
